import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "@/components/skl/Logo";

interface PolicyLayoutProps {
  title: string;
  updated: string;
  children: ReactNode;
}

export function PolicyLayout({ title, updated, children }: PolicyLayoutProps) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-foreground/10 bg-card/30 backdrop-blur-sm">
        <div className="mx-auto max-w-4xl px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <LogoMark className="h-7 w-7" />
            <span className="font-display font-bold tracking-tight">SKL-Flow</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition"
          >
            <ArrowLeft className="h-4 w-4" /> Tilbage til forsiden
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-4xl md:text-5xl font-display font-bold tracking-tight">{title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">Senest opdateret: {updated}</p>
        <div className="policy-content mt-10 space-y-8 text-[15px] leading-relaxed text-foreground/90">
          {children}
        </div>
      </main>

      <footer className="border-t border-foreground/10 bg-card/30">
        <div className="mx-auto max-w-4xl px-6 py-8 text-xs text-muted-foreground">
          © 2026 SKL-Flow. Alle rettigheder forbeholdes.
        </div>
      </footer>
    </div>
  );
}

export function PolicySection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="space-y-3">
      <h2 className="text-xl font-semibold text-foreground">{title}</h2>
      <div className="space-y-3 text-foreground/80">{children}</div>
    </section>
  );
}
